import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IAccount } from "../models/account/IAccount";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

export default function useRsCoreAccount(componentName = "useRsCoreAccount") {
  const { get } = useApiHelper(apiConfig(componentName));

  const rsCoreAccount = useQuery({
    queryKey: ["accounts", "rs-core"],
    queryFn: () => get<DefaultResponseWithData<IAccount>>("/account/rs-core"),
    staleTime: 1000 * 60 * 10,
  });

  return {
    rsCoreAccount,
  };
}
